// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"7f1e7816","627":"60cb9cf2","852":"2e9b9862","873":"05c57905","960":"4a2b1d98"}[chunkId] + ".css";
};